<template>
	<div>
		<h3 class="mb-3">Chat</h3>
		<div>
			<div class="card">
				<div class="card-body">
					<div class="row mt-3" v-for="message in messages">

						<div class="col-md-3">
							<b>{{message.from}}</b>
						</div>

						<div class="col">
							<p>{{ message.text }}</p>
						</div>
					</div>

					<div class="row">
						<div class="col-md-10">
							<input type="text" placeholder="message" v-model="newMessage" class="form-control">
						</div>

						<button type="button" class="btn btn-success" @click="addMessage()">Send</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import firebase from 'firebase'

	export default {
		name: 'Chat',
		data() {
			return {
				newMessage : '',
				messages : [
					{ from : 'Robin', text : 'Hi' },
					{ from : 'Simon', text : 'Could you please allocate 5 % more resources to the Building deliverable?' },
					{ from : 'Paul', text : 'You can only take 2 % from Drawings deliverables, else im out.' },
					{ from : 'Simon', text : 'I will take 2 % from Drawings and 3 % from Administration.' },
				]
			}
		},
		methods : {
			addMessage() {
				if(this.newMessage == '') return;
				var username = firebase.auth().currentUser.displayName;
				console.log(username)
				this.messages.push({ from : username, text : this.newMessage });
				this.newMessage = '';
			}
		}
	}
</script>

<style type="text/css">
	
</style>


// WEBPACK FOOTER //
// src/components/Chat.vue